import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageInfoNavHeader from '../../../../../shared/components/PageInfoNavHeader';

// import { CgUserlane } from 'react-icons/cg';
// import { FaVrCardboard, FaPhoneAlt } from 'react-icons/fa';

// import { EmptyField } from '../../../../../../Components/EmptyField';
// import { customerDetails } from '../../../../../../Services/fakeDatas';
// import OiButton from '../../../../../../Components/Common/OiButton/OiButton';
// import { capitalize } from 'lodash';

class SplitPaymentDetail extends Component {
    state = {
        activeNav: 'split payment detail'
    };

    handleActive = isActive => {
        this.setState({ activeNav: isActive });
    };

    render() {
        const { activeNav } = this.state;

        return (
            <div className="oi-screen padding-top-none">
                <PageInfoNavHeader
                    emoji={'👈'}
                    pageName={'Split Payment'}
                    navList={[
                        { name: 'split payment', path: '/split-payment' },
                        { name: 'split payment detail', path: null }
                    ]}
                    activeNav={activeNav}
                    handleActiveNav={this.handleActive}
                />

                <div className="oi-table-pry__section oi-table-pry__section--padding">
                    <div className="oi-table-pry__container">
                        <div className="oi-table-pry__wrapper">
                            <div className="oi-sub-header">
                                <div className="oi-sub-header__nav" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ Util, Customers }) => {
    const { isToggled } = Util;

    return {
        isToggled
    };
};

export default connect(mapStateToProps)(SplitPaymentDetail);
